module.exports = __webpack_public_path__ + "static/img/192_TO8_2085_og.a060c37.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/192_TO8_2085_og.jpg
// module id = xvPS
// module chunks = 0